<template>
  <div
    class="admin-confirm-view trail"
    :class="[`rootstate-${confirmState.value}`]">
    <div
      class="confirm-view-content"
    >
      <div
        class="state-loading"
        v-if="confirmState.isLoading">
        <rz-request-state :state="state" />
       <div class="overlay">
          <div class="wrapper">
            <div class="header">
              <h1 v-if="title" class="title">{{title}}</h1>
              <button
                aria-label="Close"
                class="btn btn-sm close"
                @click="doCancel"
              >X</button>
            </div>
            <div class="body">
              <rz-request-state :state="state" />
              <slot name="loading"></slot>
            </div>
          </div>
        </div>
      </div>
      <div
        class="state-loading"
        v-else-if="confirmState.isError">
        <div class="overlay">
          <div class="wrapper">
            <div class="header">
              <h1 v-if="title" class="title">{{title}}</h1>
              <button
                aria-label="Close"
                class="btn btn-sm close"
                @click="doCancel"
              >X</button>
            </div>
            <div class="body">
              <rz-request-state :state="state" />
              <slot name="error"></slot>
            </div>
          </div>
        </div>
      </div>
      <div
        class="state-loading"
        v-else-if="confirmState.isLinkGenerated">
        <div class="overlay">
          <div class="wrapper">
            <div class="header">
              <h1 v-if="title" class="title">{{title}}</h1>
              <button
                aria-label="Close"
                class="btn btn-sm close"
                @click="doCancel"
              >X</button>
            </div>
            <div class="body">
              <rz-request-state :state="state" />
              <slot name="linkGenerated"></slot>
            </div>
          </div>
        </div>
      </div>
      <div
        class="state-confirm"
        v-else-if="confirmState.isAskConfirm"
      >
        <div class="overlay">
            <div class="wrapper">
              <div class="header">
                <h1 v-if="title" class="title">{{title}}</h1>
                <button
                  aria-label="Close"
                  class="btn btn-sm close"
                  @click="doCancel"
                >X</button>
              </div>
              <div class="body">
                <p v-if="message">{{message}}</p>
                <slot name="confirm"></slot>
                <p v-if="data.error" class="error">{{data.error}}</p>
                <div class="tools">
                  <button
                    class="btn btn-sm"
                    :disabled="confirmDisabled"
                    @click="doAction"
                  >Confirm</button>
                </div>
             </div>
            </div>
        </div>
      </div>
      <div
        class="state-completed"
        v-else-if="confirmState.isCompleted"
      >
        <slot name="completed">
          <span class="success">👍</span>
        </slot>
      </div>

      <div
        class="state-normal"
        v-if="showNormalState"
      >
        <button
          aria-label="Add Package"
          :class="[actionButtonClass]"
          @click="doActionClick"
        >Add Trial</button>
        <slot name="normal"></slot>
      </div>
    </div>
  </div>
</template>
<script>
import {
  ref,
  reactive,
  watch,
  computed,
} from 'vue';
import { RequestState, RequestStateStatus } from '@/api/core';
import { Enum } from '@/core/utils/enum';

const ConfirmState = new Enum({
  Normal: 'Normal',
  Loading: 'Loading',
  Error: 'Error',
  AskConfirm: 'AskConfirm',
  Completed: 'Completed',
  LinkGenerated: 'LinkGenerated',
});

export default {
  props: {
    action: Object,
    title: {
      type: String,
      default: 'Are you sure?',
    },
    actionButtonClass: {
      type: String,
      default: 'btn btn-sm',
    },
    message: {
      type: String,
      default: '',
    },
    confirmDisabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const state = ref(new RequestState());
    const confirmState = ref(ConfirmState.Normal);
    const showDone = ref(false);
    const data = reactive({
      error: '',
    });

    const doAction = () => {
      emit('on-action-loading', props.action);
      state.value.status = RequestStateStatus.Loading;
      confirmState.value = ConfirmState.Loading;

      showDone.value = false;
      props.action.fn().then((response) => {
        if (response && response.code !== 40001) {
          state.value.status = RequestStateStatus.Loaded;
          // confirmState.value = ConfirmState.Completed;
          confirmState.value = ConfirmState.LinkGenerated;
          props.action.cancelAsk();
          showDone.value = true;
          emit('on-action-done', props.action, response);
        } else if (response.code === 40001) {
          confirmState.value = ConfirmState.Error;
          state.value.ref = response;
          state.value.status = RequestStateStatus.Error;
          props.action.cancelAsk();
          emit('on-action-error', props.action, response.message);
        }
      }).catch((err) => {
        confirmState.value = ConfirmState.Error;
        state.value.ref = err;
        state.value.status = RequestStateStatus.Error;
        props.action.cancelAsk();
        emit('on-action-error', props.action, err);
      });
    };

    const doInit = () => {
      state.value.status = RequestStateStatus.NotInit;
      confirmState.value = ConfirmState.Normal;
    };

    const doCancel = () => {
      doInit();
      props.action.cancel();
      emit('cancel', props.action);
    };

    const doActionClick = () => {
      doInit();
      props.action.askConfirm();
      emit('on-action-click', props.action);
    };

    watch(() => props.action.ask, () => {
      if (props.action.ask && state.value.status.isLoaded) {
        doInit();
      } else if (props.action.ask && confirmState.value.isNormal) {
        confirmState.value = ConfirmState.AskConfirm;
      }
    });

    const showNormalState = computed(() => {
      if (confirmState.value.isLoading) {
        return false;
      }

      if (confirmState.value.isAskConfirm) {
        return false;
      }

      return true;
    });

    return {
      confirmState,
      doAction,
      doCancel,
      state,
      data,
      showDone,
      showNormalState,
      doActionClick,
    };
  },
};
</script>
<style lang="scss" scoped>
.admin-confirm-view {
  &.package {
    width: auto;

    button {
      &.btn {
        margin-right: 0;
      }
    }
  }
  .view-btn {
    text-decoration: underline;
    color: var(--admin--color-level2);
    cursor: pointer;
  }
  .state-confirm, .state-loading {
    .overlay {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      background: var(--admin--color-previewbg);
      height: 100vh;
      z-index: 100;
      .wrapper {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 100;
        width: size(530);
        overflow: hidden;
        z-index: 101;
        .header {
          background: var(--admin--color-level4);
          padding: size(5) 0 size(5) size(25);
          h1 {
            display: inline-block;
            width: 90%;
            text-transform: uppercase;
          }
          .close {
            float: right;
            background: none;
          }
        }
        .body {
          background: var(--admin--color-level3);
          overflow: hidden;
          max-height: size(480);
          padding: size(25);
        }
      }
    }
  }
}
</style>
